<div class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Users</h1>
            </div>
            <!-- /.col -->
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a href="#">Home</a></li>
                    <li class="breadcrumb-item active">Users</li>
                </ol>
            </div>
            <!-- /.col -->
        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</div>
<!-- /.content-header -->
<section class="content">
    <div class="container-fluid">
        <!-- <form [formGroup]="filterForm" (ngSubmit)="applyFilters()">
            <label>Name Filter:</label>
            <input type="text" formControlName="nameFilter">
            
            <label>Email Filter:</label>
            <input type="text" formControlName="emailFilter">
            
            <label>Phone Filter:</label>
            <input type="text" formControlName="phoneFilter">
            
            <button type="submit">Apply Filter</button>
          </form> -->
        <p-table [value]="users" [tableStyle]="{ 'min-width': '50rem' }">
            
            <ng-template pTemplate="header" >
                <tr>
                    <th>Name</th>
                    <th>Email Id</th>
                    <th>Phone No</th>
                    <th>Title</th>
                    
                    
                </tr>
               
            </ng-template>
            <ng-template pTemplate="body" let-user>
                <tr>
                    <td>{{ user.name }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.phone }}</td>
                    <td>{{ getFarmType(user.title) }}</td>
                    
                    
                </tr>
            </ng-template>
        </p-table>
        <p-paginator [rows]="pageSize" [totalRecords]="totalRecords" (onPageChange)="onPageChange($event)"></p-paginator>
    </div>
</section>